<template>
  <c-layout :spinning="page.loading">
    <!--    <F-Header/>-->
    <div class="excel-parent">
      <div id="excelView" :style="spreadStyle" style="display: none;"></div>
    </div>
    <!--    <F-Footer/>-->
  </c-layout>
</template>

<script>
// @ is an alias to /src
import FHeader from "@/views/portal/F-Header";
import FFooter from "@/views/portal/F-Footer";

export default {
  name: 'view-excel',
  components: {FHeader, FFooter},
  data() {
    return {
      page: {
        loading: false
      },
      path: '',
      spreadStyle: {
        width: '100%',
        height: '100%'
      },
      spread: null,
      excelIo: null,
    }
  },
  mounted() {
    this.path = this.$route.query.path
    this.viewFile()
  },
  methods: {
    viewFile() {
      const _this = this
      _this.page.loading = true;
      let excelView = document.querySelector('#excelView')
      // 在mounted中声明 spread 和excelIo ，避免了改变某个参数后再次请求数据渲染界面的问题，若在 openExcel方法中声明会在该excel下方再生成一个excel
      _this.spread = new GC.Spread.Sheets.Workbook(excelView);
      _this.excelIo = new GC.Spread.Excel.IO();
      _this.openExcel(this.path)
      _this.page.loading = false;
    },
    openExcel(path) {
      const _this = this
      this.$http.get(path, {responseType: 'blob'}).then(response => {
        let blob = new Blob([response])
        _this.excelIo.open(blob, function (json) {
	    	document.getElementById('excelView').style.display = "";
          	//console.log(json)
          	_this.spread.fromJSON(json);
          	_this.spread.options.tabNavigationVisible = false;
          	_this.spread.options.tabEditable = false;
          	_this.spread.options.allowSheetReorder = false;
          	_this.spread.options.newTabVisible = false;
          	_this.spread.getActiveSheet().options.isProtected = true;//设置Excel单元格保护，禁止在线编辑
		}, function (e) {
          _this.$message.error(e.errorMessage);
        }, {});
      })
    },
  }
}
</script>
<style scoped>
@import "~@public/reset.css";
@import "~@public/infoShow.css";

.excel-parent {
  width: 100%;
  height: 100vh;
  margin: 5px auto;
  padding: 20px;
  border: 1px solid #aca7a7;
}

.intro-a :hover {
  background-color: lightcyan;
  cursor: pointer;
}

</style>
